module.exports = __webpack_public_path__ + "media/images/logo-collapsed-34a800a4f4129a8df954b57f5c7fea4b.svg";